import { render } from "./DriverReturns.vue?vue&type=template&id=22dd8166&scoped=true"
import script from "./DriverReturns.vue?vue&type=script&lang=js"
export * from "./DriverReturns.vue?vue&type=script&lang=js"

import "./DriverReturns.vue?vue&type=style&index=0&id=22dd8166&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dd8166"]])

export default __exports__